import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "weekly-report-drawer" }
const _hoisted_2 = {
  key: 0,
  class: "weekly-report-decision-hold",
  "data-testid": "weekly-report-decision-hold"
}
const _hoisted_3 = {
  key: 1,
  "data-testid": "weekly-report-goal-analysis"
}
const _hoisted_4 = {
  key: 0,
  class: "weekly-report-goal-text"
}
const _hoisted_5 = {
  key: 1,
  class: "weekly-report-muted"
}
const _hoisted_6 = {
  key: 2,
  class: "weekly-report-goal-meta"
}
const _hoisted_7 = {
  key: 3,
  class: "weekly-report-analysis-error"
}
const _hoisted_8 = {
  key: 4,
  class: "weekly-report-muted"
}
const _hoisted_9 = {
  key: 5,
  class: "weekly-report-muted"
}
const _hoisted_10 = { class: "weekly-report-analysis-summary" }
const _hoisted_11 = ["data-status"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "goal-status is-hypothesis"
}
const _hoisted_14 = {
  key: 0,
  class: "weekly-report-direction"
}
const _hoisted_15 = { class: "weekly-report-plan-head" }
const _hoisted_16 = ["data-testid", "disabled", "onClick"]
const _hoisted_17 = {
  key: 2,
  class: "weekly-report-unmeasurable"
}
const _hoisted_18 = {
  key: 2,
  "data-testid": "weekly-report-ai-answer-opportunities"
}
const _hoisted_19 = {
  key: 0,
  class: "weekly-report-analysis-error"
}
const _hoisted_20 = {
  key: 1,
  class: "weekly-report-muted"
}
const _hoisted_21 = ["data-testid"]
const _hoisted_22 = { class: "weekly-report-plan-head" }
const _hoisted_23 = ["data-testid", "disabled", "onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "weekly-report-hypotheses"
}
const _hoisted_26 = {
  key: 1,
  class: "weekly-report-hypotheses"
}
const _hoisted_27 = {
  key: 2,
  class: "weekly-report-plan-warning"
}
const _hoisted_28 = {
  key: 3,
  class: "weekly-report-plan-warning"
}
const _hoisted_29 = {
  key: 4,
  class: "weekly-report-plan-warning"
}
const _hoisted_30 = { class: "weekly-report-score-details" }
const _hoisted_31 = { class: "weekly-report-muted" }
const _hoisted_32 = {
  key: 5,
  class: "weekly-report-muted"
}
const _hoisted_33 = {
  key: 3,
  "data-testid": "weekly-report-article-outcomes"
}
const _hoisted_34 = {
  key: 0,
  class: "weekly-report-muted"
}
const _hoisted_35 = { class: "weekly-report-plan-head" }
const _hoisted_36 = {
  key: 0,
  class: "goal-status is-achieved"
}
const _hoisted_37 = {
  key: 0,
  class: "weekly-report-plan-warning"
}
const _hoisted_38 = {
  key: 1,
  class: "weekly-report-plan-warning"
}
const _hoisted_39 = {
  key: 0,
  class: "weekly-report-integration-grid"
}
const _hoisted_40 = {
  key: 1,
  class: "weekly-report-muted"
}
const _hoisted_41 = {
  key: 2,
  class: "weekly-report-notices"
}
const _hoisted_42 = { key: 4 }
const _hoisted_43 = {
  key: 0,
  class: "weekly-report-wordpress-guide",
  "data-testid": "weekly-report-wordpress-guide"
}
const _hoisted_44 = {
  key: 1,
  class: "weekly-report-muted"
}
const _hoisted_45 = { class: "weekly-report-plan-head" }
const _hoisted_46 = ["data-testid", "disabled", "onClick"]
const _hoisted_47 = {
  key: 0,
  class: "weekly-report-plan-warning"
}
const _hoisted_48 = {
  key: 3,
  class: "weekly-report-created-drafts"
}
const _hoisted_49 = { class: "weekly-report-retention" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleGateReadinessNotice = _resolveComponent("ArticleGateReadinessNotice")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "weekly-report-drawer-backdrop",
    "data-testid": "weekly-report-detail",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "週次レポート詳細", -1)),
          _createElementVNode("h2", null, _toDisplayString(_ctx.detail.report.source_title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.detail.report.week_start_date) + "〜" + _toDisplayString(_ctx.detail.report.week_end_date), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "閉じる",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      (_ctx.decisionBlocked)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.detail.report.decision_label || "判断保留・計測確認"), 1),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "公開ページファネルの計測整合性を確認するまで、総合点とLP・CTA・記事の改善提案を停止しています。", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "不整合の詳細はHTMLレポートの「判断保留・計測確認」を確認してください。", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.detail.report.source_type === 'marketing_campaign' && !_ctx.decisionBlocked)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "weekly-report-section-title" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "目標連動分析"),
                _createElementVNode("p", null, "AIによる助言です。実績と固定ルール採点は変更しておらず、仮説は確認済み事実ではありません。")
              ])
            ], -1)),
            _cache[27] || (_cache[27] = _createElementVNode("h4", null, "参照した目標・計画", -1)),
            (_ctx.detail.campaign_goal_snapshot?.configured)
              ? (_openBlock(), _createElementBlock("pre", _hoisted_4, _toDisplayString(_ctx.detail.campaign_goal_snapshot.prompt_text), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "目標・計画は未設定です。施策詳細から設定できます。")),
            (_ctx.detail.campaign_goal_snapshot?.configured)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, " 版 " + _toDisplayString(_ctx.detail.campaign_goal_snapshot.version) + "・固定日時 " + _toDisplayString(_ctx.detail.campaign_goal_snapshot.captured_at || "記録なし"), 1))
              : _createCommentVNode("", true),
            (_ctx.detail.goal_analysis?.status === 'failed')
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 目標連動分析を生成できませんでした。レポート本体の実績と採点は利用できます。 "))
              : (!_ctx.detail.campaign_goal_snapshot?.configured)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 目標が未設定のため、AI分析は実行していません。 "))
                : (_ctx.detail.goal_analysis?.status !== 'succeeded')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 目標連動分析は生成されていません。レポート本体の実績と採点は利用できます。 "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.detail.goal_analysis.result.goal_summary), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.detail.goal_analysis.result.analysis_summary), 1)
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("h4", null, "目標ごとの達成状況・差分", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.goal_analysis.result.goal_gaps || [], (gap) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: gap.goal_reference_id,
                          class: "weekly-report-goal-card",
                          "data-status": gap.status
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`goal-status is-${gap.status}`)
                            }, _toDisplayString(_ctx.goalStatusLabel(gap.status)), 3),
                            _createElementVNode("span", {
                              class: _normalizeClass(`priority is-${gap.priority}`)
                            }, _toDisplayString(_ctx.priorityLabel(gap.priority)), 3)
                          ]),
                          _createElementVNode("h5", null, _toDisplayString(gap.goal), 1),
                          _createElementVNode("p", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "確認済み実績：", -1)),
                            _createTextVNode(_toDisplayString(gap.current_actual), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("strong", null, "差分：", -1)),
                            _createTextVNode(_toDisplayString(gap.difference), 1)
                          ]),
                          (gap.constraints.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                _cache[7] || (_cache[7] = _createElementVNode("strong", null, "制約：", -1)),
                                _createTextVNode(_toDisplayString(gap.constraints.join("／")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gap.evidence_refs, (ref) => {
                            return (_openBlock(), _createElementBlock("small", {
                              key: ref,
                              class: "weekly-report-evidence"
                            }, _toDisplayString(_ctx.evidenceLabel(ref)), 1))
                          }), 128))
                        ], 8, _hoisted_11))
                      }), 128)),
                      _cache[23] || (_cache[23] = _createElementVNode("h4", null, "優先改善点", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.goal_analysis.result.improvements || [], (item) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.title,
                          class: "weekly-report-goal-card"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`priority is-${item.priority}`)
                            }, _toDisplayString(_ctx.priorityLabel(item.priority)), 3),
                            (item.hypothesis)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "仮説"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("h5", null, _toDisplayString(item.title), 1),
                          _createElementVNode("p", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("strong", null, "根拠：", -1)),
                            _createTextVNode(_toDisplayString(item.rationale), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("strong", null, "次の行動：", -1)),
                            _createTextVNode(_toDisplayString(item.next_action), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("strong", null, "KPI：", -1)),
                            _createTextVNode(_toDisplayString(item.kpis.join("、")), 1)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.detail.goal_analysis.result.next_week_direction)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _cache[16] || (_cache[16] = _createElementVNode("h4", null, "次週の方向性", -1)),
                            _createElementVNode("dl", null, [
                              _createElementVNode("div", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("dt", null, "継続", -1)),
                                _createElementVNode("dd", null, _toDisplayString(_ctx.directionText("continue_actions")), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("dt", null, "修正", -1)),
                                _createElementVNode("dd", null, _toDisplayString(_ctx.directionText("change_actions")), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("dt", null, "中止・保留", -1)),
                                _createElementVNode("dd", null, _toDisplayString(_ctx.directionText("pause_actions")), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[14] || (_cache[14] = _createElementVNode("dt", null, "新規検証", -1)),
                                _createElementVNode("dd", null, _toDisplayString(_ctx.directionText("new_tests")), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("dt", null, "確認指標", -1)),
                                _createElementVNode("dd", null, _toDisplayString(_ctx.directionText("kpis")), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _cache[24] || (_cache[24] = _createElementVNode("h4", null, "目標に沿った記事案", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "weekly-report-muted" }, "goal_aiの案はAI仮説です。明示的に選んだ案だけを提案下書きへ渡し、本文生成・投稿・公開は開始しません。", -1)),
                      (_ctx.detail.wordpress_connected && (_ctx.detail.goal_analysis.result.article_ideas || []).length > 0)
                        ? (_openBlock(), _createBlock(_component_ArticleGateReadinessNotice, {
                            key: 1,
                            readiness: _ctx.detail.article_gate_readiness || null
                          }, null, 8, ["readiness"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.goal_analysis.result.article_ideas || [], (idea, index) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: `${idea.goal_reference_id}-${index}`,
                          class: "weekly-report-plan is-goal-ai"
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(`priority is-${idea.priority}`)
                              }, _toDisplayString(_ctx.priorityLabel(idea.priority)), 3),
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "goal-status is-hypothesis" }, "AI仮説・goal_ai", -1)),
                              _createElementVNode("h4", null, _toDisplayString(idea.provisional_title), 1),
                              _createElementVNode("p", null, _toDisplayString(idea.target_audience) + "・" + _toDisplayString(idea.search_intent), 1)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              "data-testid": `weekly-report-create-goal-ai-article-${index}`,
                              disabled: !_ctx.detail.wordpress_connected || _ctx.creatingPlanIndex != null,
                              onClick: ($event: any) => (_ctx.$emit('create-draft', { index, origin: 'goal_ai' }))
                            }, _toDisplayString(_ctx.creatingPlanIndex === index ? "作成中…" : "提案下書きを作成"), 9, _hoisted_16)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(idea.purpose), 1),
                          _createElementVNode("ol", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idea.outline, (heading) => {
                              return (_openBlock(), _createElementBlock("li", { key: heading }, _toDisplayString(heading), 1))
                            }), 128))
                          ]),
                          _createElementVNode("dl", null, [
                            _createElementVNode("div", null, [
                              _cache[18] || (_cache[18] = _createElementVNode("dt", null, "CTA", -1)),
                              _createElementVNode("dd", null, _toDisplayString(idea.cta), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("dt", null, "公開後KPI", -1)),
                              _createElementVNode("dd", null, _toDisplayString(idea.post_publish_kpis.join("、")), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("dt", null, "重複確認", -1)),
                              _createElementVNode("dd", null, _toDisplayString(idea.duplicate_check_required ? "必要" : "必須ではない"), 1)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.detail.goal_analysis.result.unmeasurable_items?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[21] || (_cache[21] = _createElementVNode("h4", null, "評価不能項目・制約", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.goal_analysis.result.unmeasurable_items, (item) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: item.goal_reference_id
                              }, [
                                _createElementVNode("strong", null, _toDisplayString(item.goal), 1),
                                _createTextVNode(" — " + _toDisplayString(item.reason), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.detail.report.source_type === 'marketing_campaign' && !_ctx.decisionBlocked)
        ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "weekly-report-section-title" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "AI回答機会"),
                _createElementVNode("p", null, "GSCの観測値から、どの質問へどのページと根拠で答えるかを整理します。優先度は掲載確率・AI採用率・成功率ではありません。")
              ])
            ], -1)),
            (_ctx.detail.ai_answer_opportunities?.status === 'failed')
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, " AI回答機会を分類できませんでした。週次集計と目標分析は利用できます。 "))
              : (!_ctx.detail.ai_answer_opportunities?.opportunities?.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, " このレポートに表示できるAI回答機会はありません。旧レポートでは未生成の場合があります。 "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[44] || (_cache[44] = _createElementVNode("p", { class: "weekly-report-muted" }, [
                      _createElementVNode("span", { class: "goal-status is-achieved" }, "観測値"),
                      _createTextVNode("はSearch Console由来、"),
                      _createElementVNode("span", { class: "goal-status is-hypothesis" }, "仮説"),
                      _createTextVNode("はAIによる企画候補です。GA4はランディングページ単位の参考値です。 ")
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.ai_answer_opportunities.opportunities, (opportunity, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: opportunity.opportunity_id,
                        class: "weekly-report-plan is-ai-answer",
                        "data-testid": `weekly-report-ai-answer-opportunity-${index}`
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`priority is-${_ctx.scorePriority(opportunity.priority_score)}`)
                            }, "編集優先度 " + _toDisplayString(opportunity.priority_score) + "/100", 3),
                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "goal-status is-hypothesis" }, "主質問は仮説", -1)),
                            _createElementVNode("h4", null, _toDisplayString(opportunity.primary_question), 1),
                            _createElementVNode("p", null, _toDisplayString(opportunity.audience) + "・" + _toDisplayString(_ctx.intentLabel(opportunity.search_intent)), 1)
                          ]),
                          (opportunity.recommended_action === 'new_article')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                "data-testid": `weekly-report-create-ai-answer-article-${index}`,
                                disabled: !_ctx.detail.wordpress_connected || _ctx.creatingPlanIndex != null,
                                onClick: ($event: any) => (_ctx.$emit('create-draft', { index, origin: 'ai_answer_opportunity', opportunityId: opportunity.opportunity_id }))
                              }, _toDisplayString(_ctx.creatingPlanIndex === index ? "作成中…" : "新規記事の提案へ渡す"), 9, _hoisted_23))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("dl", null, [
                          _createElementVNode("div", null, [
                            _cache[30] || (_cache[30] = _createElementVNode("dt", null, "GSC観測query", -1)),
                            _createElementVNode("dd", null, [
                              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "goal-status is-achieved" }, "観測値", -1)),
                              _createTextVNode(_toDisplayString(opportunity.target_query), 1)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[31] || (_cache[31] = _createElementVNode("dt", null, "推奨", -1)),
                            _createElementVNode("dd", null, _toDisplayString(_ctx.aiAnswerActionLabel(opportunity.recommended_action)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[32] || (_cache[32] = _createElementVNode("dt", null, "観測値", -1)),
                            _createElementVNode("dd", null, "表示 " + _toDisplayString(_ctx.number(opportunity.observed_signals.gsc_query.impressions)) + " / クリック " + _toDisplayString(_ctx.number(opportunity.observed_signals.gsc_query.clicks)) + " / 順位 " + _toDisplayString(_ctx.decimal(opportunity.observed_signals.gsc_query.position)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[33] || (_cache[33] = _createElementVNode("dt", null, "対象ページ", -1)),
                            _createElementVNode("dd", null, _toDisplayString(opportunity.current_landing_page || "新規ページ候補"), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[34] || (_cache[34] = _createElementVNode("dt", null, "一次情報", -1)),
                            _createElementVNode("dd", null, _toDisplayString(opportunity.first_party_evidence_available ? "利用可能" : "不足"), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[35] || (_cache[35] = _createElementVNode("dt", null, "コンテンツ差分", -1)),
                            _createElementVNode("dd", null, _toDisplayString(_ctx.contentGapLabel(opportunity.content_gap)), 1)
                          ]),
                          (opportunity.skip_reason)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _cache[36] || (_cache[36] = _createElementVNode("dt", null, "見送り理由", -1)),
                                _createElementVNode("dd", null, _toDisplayString(opportunity.skip_reason), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (opportunity.supporting_question_hypotheses.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _cache[37] || (_cache[37] = _createElementVNode("strong", null, "補助質問（仮説）", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.supporting_question_hypotheses, (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.text
                                  }, _toDisplayString(item.text), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (opportunity.query_fanout_hypotheses.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _cache[38] || (_cache[38] = _createElementVNode("strong", null, "query fan-out候補（仮説）", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.query_fanout_hypotheses, (item) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: item.text
                                  }, _toDisplayString(item.text), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (opportunity.evidence_gaps.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _cache[39] || (_cache[39] = _createElementVNode("strong", null, "必要な根拠", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.evidence_gaps, (gap) => {
                                  return (_openBlock(), _createElementBlock("li", { key: gap }, _toDisplayString(gap), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (opportunity.cannibalization_warnings.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _cache[40] || (_cache[40] = _createElementVNode("strong", null, "競合・カニバリゼーション", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.cannibalization_warnings, (warning) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: `${warning.code}-${warning.message}`
                                  }, _toDisplayString(warning.message), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (opportunity.readiness_blockers.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _cache[41] || (_cache[41] = _createElementVNode("strong", null, "技術的ブロッカー", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.readiness_blockers, (blocker) => {
                                  return (_openBlock(), _createElementBlock("li", { key: blocker }, _toDisplayString(blocker), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("details", _hoisted_30, [
                          _cache[42] || (_cache[42] = _createElementVNode("summary", null, "優先度の理由", -1)),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opportunity.score_factors, (factor) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: factor.factor
                              }, _toDisplayString(_ctx.scoreFactorLabel(factor.factor)) + "：正規化 " + _toDisplayString(factor.normalized) + " × 重み " + _toDisplayString(factor.weight) + " = " + _toDisplayString(factor.points) + "点 ", 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_31, [
                          _cache[43] || (_cache[43] = _createElementVNode("strong", null, "公開後KPI：", -1)),
                          _createTextVNode(_toDisplayString(_ctx.kpiText(opportunity.post_publish_kpis)), 1)
                        ]),
                        (opportunity.recommended_action !== 'new_article')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_32, " 既存記事の自動更新・自動公開は行いません。 "))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_21))
                    }), 128))
                  ], 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.detail.report.source_type === 'marketing_campaign' && !_ctx.decisionBlocked)
        ? (_openBlock(), _createElementBlock("section", _hoisted_33, [
            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "weekly-report-section-title" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "公開記事の監査・成果計測"),
                _createElementVNode("p", null, "技術状態、インデックス、query cohort、ランディングページ成果、人による標本観測を週次で確認します。")
              ])
            ], -1)),
            (!_ctx.detail.article_outcomes?.articles?.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, "公開済み記事の成果スナップショットはありません。"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.article_outcomes?.articles || [], (item) => {
              return (_openBlock(), _createElementBlock("article", {
                key: item.article_id,
                class: "weekly-report-plan"
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", null, [
                    (item.newly_published)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "新規公開"))
                      : _createCommentVNode("", true),
                    _createElementVNode("h4", null, _toDisplayString(item.title || item.published_url), 1),
                    _createElementVNode("p", null, _toDisplayString(item.published_at || "公開日時未記録"), 1)
                  ])
                ]),
                _createElementVNode("dl", null, [
                  _createElementVNode("div", null, [
                    _cache[46] || (_cache[46] = _createElementVNode("dt", null, "技術的掲載資格", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_ctx.outcomeStatusLabel(item.technical_eligibility?.status)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[47] || (_cache[47] = _createElementVNode("dt", null, "インデックス状態", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_ctx.outcomeStatusLabel(item.index_status?.status)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[48] || (_cache[48] = _createElementVNode("dt", null, "GSC query cohort", -1)),
                    _createElementVNode("dd", null, "表示 " + _toDisplayString(_ctx.number(item.gsc_query_cohort?.impressions || 0)) + " / クリック " + _toDisplayString(_ctx.number(item.gsc_query_cohort?.clicks || 0)) + " / 順位 " + _toDisplayString(_ctx.decimal(item.gsc_query_cohort?.position || 0)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[49] || (_cache[49] = _createElementVNode("dt", null, "GSC公開URL", -1)),
                    _createElementVNode("dd", null, "表示 " + _toDisplayString(_ctx.number(item.gsc_page?.impressions || 0)) + " / クリック " + _toDisplayString(_ctx.number(item.gsc_page?.clicks || 0)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[50] || (_cache[50] = _createElementVNode("dt", null, "GA4ランディングページ", -1)),
                    _createElementVNode("dd", null, "sessions " + _toDisplayString(_ctx.number(item.ga4_landing_page?.sessions || 0)) + " / key events " + _toDisplayString(_ctx.number(item.ga4_landing_page?.key_events || 0)) + "（query帰属なし）", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[51] || (_cache[51] = _createElementVNode("dt", null, "waaq匿名導線", -1)),
                    _createElementVNode("dd", null, "CTA " + _toDisplayString(_ctx.number(item.waaq_funnel?.article_cta_click || 0)) + " / LP到達 " + _toDisplayString(_ctx.number(item.waaq_funnel?.service_lp_arrival || 0)) + " / form " + _toDisplayString(_ctx.number(item.waaq_funnel?.form_complete || 0)) + " / booking " + _toDisplayString(_ctx.number(item.waaq_funnel?.booking_confirmed || 0)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[52] || (_cache[52] = _createElementVNode("dt", null, "生成AI検索", -1)),
                    _createElementVNode("dd", null, "ページ別impressions " + _toDisplayString(_ctx.number(item.generative_ai_page?.impressions || 0)) + "（query・CV帰属なし）", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[53] || (_cache[53] = _createElementVNode("dt", null, "最終判断", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_ctx.outcomeActionLabel(item.final_decision || item.recommended_actions?.[0])) + " / " + _toDisplayString(item.decision_policy_version || "旧version"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("dt", null, "回答ブロック計画", -1)),
                    _createElementVNode("dd", null, _toDisplayString(item.answer_block_plan?.length || 0) + "件", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[55] || (_cache[55] = _createElementVNode("dt", null, "人による標本観測", -1)),
                    _createElementVNode("dd", null, _toDisplayString(item.manual_observations?.length || 0) + "件", 1)
                  ])
                ]),
                (item.data_quality?.decision_allowed === false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[56] || (_cache[56] = _createElementVNode("strong", null, "判断停止", -1)),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data_quality?.blocking_reasons || [], (reason) => {
                          return (_openBlock(), _createElementBlock("li", { key: reason }, _toDisplayString(reason), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.evidence_updates_required?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _cache[57] || (_cache[57] = _createElementVNode("strong", null, "根拠更新が必要", -1)),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.evidence_updates_required, (entry) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${entry.question_id}-${entry.review_by}`
                          }, _toDisplayString(entry.requirement), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _cache[58] || (_cache[58] = _createElementVNode("strong", null, "次の推奨アクション：", -1)),
                  _createTextVNode(_toDisplayString(item.recommended_actions.map(_ctx.outcomeActionLabel).join("、")), 1)
                ]),
                _cache[59] || (_cache[59] = _createElementVNode("p", { class: "weekly-report-muted" }, "公開前後差分は相関です。記事の自動変更・自動再公開は行いません。", -1))
              ]))
            }), 128)),
            _cache[61] || (_cache[61] = _createElementVNode("p", { class: "weekly-report-muted" }, "Search ConsoleからAI Overviews／AI Modeへの掲載は直接判定できません。人手記録は網羅的掲載率ではありません。", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", null, [
        _cache[62] || (_cache[62] = _createElementVNode("h3", null, "連携・計測状態", -1)),
        (_ctx.detail.integration_statuses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.integration_statuses, (status) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${status.provider}-${status.last_synced_at || ''}`
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.providerLabel(status.provider)), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(status.status === 'connected' ? 'is-ok' : 'is-warning')
                  }, _toDisplayString(status.status), 3),
                  _createElementVNode("small", null, "最終同期: " + _toDisplayString(status.last_synced_at || "未取得"), 1)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_40, "外部連携のない公開ページ単体レポートです。")),
        (_ctx.detail.notices.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.notices, (notice) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: notice.code
                }, _toDisplayString(notice.message), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.detail.report.source_type === 'marketing_campaign' && !_ctx.decisionBlocked)
        ? (_openBlock(), _createElementBlock("section", _hoisted_42, [
            _cache[71] || (_cache[71] = _createElementVNode("div", { class: "weekly-report-section-title" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "WordPress記事企画"),
                _createElementVNode("p", null, "明示的に選んだ企画だけを記事提案の下書きへ渡します。記事生成・公開は開始しません。")
              ])
            ], -1)),
            (!_ctx.detail.wordpress_connected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _cache[64] || (_cache[64] = _createElementVNode("strong", null, "WordPressが未連携です", -1)),
                  _cache[65] || (_cache[65] = _createElementVNode("p", null, "対象施策でWordPressを接続すると、既存記事との重複を確認して下書きを作成できます。", -1)),
                  _createVNode(_component_router_link, {
                    to: `/marketing/${_ctx.detail.report.campaign_id}`
                  }, {
                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                      _createTextVNode("施策の連携設定を開く", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : (_ctx.detail.article_plans.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, "このレポートに記事企画はありません。"))
                : _createCommentVNode("", true),
            (_ctx.detail.wordpress_connected && _ctx.detail.article_plans.length > 0)
              ? (_openBlock(), _createBlock(_component_ArticleGateReadinessNotice, {
                  key: 2,
                  readiness: _ctx.detail.article_gate_readiness || null
                }, null, 8, ["readiness"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.article_plans, (plan) => {
              return (_openBlock(), _createElementBlock("article", {
                key: plan.index,
                class: "weekly-report-plan"
              }, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`priority is-${plan.priority}`)
                    }, _toDisplayString(_ctx.priorityLabel(plan.priority)), 3),
                    _createElementVNode("h4", null, _toDisplayString(plan.target_query), 1),
                    _createElementVNode("p", null, _toDisplayString(plan.search_intent) + "・" + _toDisplayString(_ctx.recommendationLabel(plan.recommendation)), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    "data-testid": `weekly-report-create-article-${plan.index}`,
                    disabled: !_ctx.detail.wordpress_connected || _ctx.creatingPlanIndex != null,
                    onClick: ($event: any) => (_ctx.$emit('create-draft', { index: plan.index, origin: 'deterministic' }))
                  }, _toDisplayString(_ctx.creatingPlanIndex === plan.index ? "作成中…" : "提案下書きを作成"), 9, _hoisted_46)
                ]),
                _createElementVNode("dl", null, [
                  _createElementVNode("div", null, [
                    _cache[66] || (_cache[66] = _createElementVNode("dt", null, "根拠", -1)),
                    _createElementVNode("dd", null, "表示 " + _toDisplayString(_ctx.number(plan.evidence.impressions)) + " / クリック " + _toDisplayString(_ctx.number(plan.evidence.clicks)) + " / 順位 " + _toDisplayString(_ctx.decimal(plan.evidence.position)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[67] || (_cache[67] = _createElementVNode("dt", null, "推奨タイトル", -1)),
                    _createElementVNode("dd", null, _toDisplayString(plan.title_ideas?.[0] || "—"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[68] || (_cache[68] = _createElementVNode("dt", null, "対象ページ", -1)),
                    _createElementVNode("dd", null, _toDisplayString(plan.target_landing_page || "新規ページ候補"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[69] || (_cache[69] = _createElementVNode("dt", null, "CTA", -1)),
                    _createElementVNode("dd", null, _toDisplayString(plan.cta_idea || "—"), 1)
                  ])
                ]),
                (plan.cannibalization_warning)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(plan.cannibalization_warning), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.detail.article_drafts.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _cache[70] || (_cache[70] = _createElementVNode("h4", null, "このレポートから作成済み", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.article_drafts, (draft) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: draft.id
                    }, _toDisplayString(draft.target_query) + "（" + _toDisplayString(draft.status) + "）", 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", null, [
        _cache[72] || (_cache[72] = _createElementVNode("h3", null, "データの扱い", -1)),
        _cache[73] || (_cache[73] = _createElementVNode("p", { class: "weekly-report-muted" }, " GA4の時間帯情報とGSCの検索語は直接結合していません。個別セッションや個人識別子はレポートに保存しません。 ", -1)),
        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.detail.report.retention_policy.description), 1)
      ])
    ])
  ]))
}